export default "__VITE_ASSET__04bb0918__"